export enum LogoType {
  DEFAULT = 'default',
  DOCUMENT = 'document',
  FAVICON = 'favicon',
  HEADER = 'header',
  HEADER_ON_LIGHT_BG = 'headerOnLightBg',
  HOME = 'home',
  SMALL = 'small',
}
